import { FieldNormalizer } from '../types';

export default class FieldCollectionNormalizer implements FieldNormalizer {
  normalize({ fieldName, value = [] }: NormalizeParams): NormalizedFieldCollection {
    const items = value.map(({ __typename, ...values }: any) => ({ ...values }));

    return {
      items: {
        [fieldName]: items,
      },
    };
  }

  reverseNormalize(value: NormalizedFieldCollection) {
    if (typeof value.items !== 'object') return [];
    const collectionItems = Object.values(value.items)[0];
    return collectionItems.map(({ index, ...rest }: any) => rest);
  }
}

export interface NormalizeParams {
  fieldName: string;
  value: Record<string, any>[];
}

export interface NormalizedFieldCollection {
  replace?: boolean;
  items: Record<string, FieldCollectionValue[]>;
}

export interface FieldCollectionValue {
  index: number;
  [key: string]: any;
}
